import { render, staticRenderFns } from "./AddItemDetail.vue?vue&type=template&id=4628f6d4&"
import script from "./AddItemDetail.vue?vue&type=script&lang=js&"
export * from "./AddItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./AddItemDetail.vue?vue&type=style&index=0&id=4628f6d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports